import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Link } from '@uhg-abyss/web/ui/Link';
import { config } from '@uhg-abyss/web/tools/config';
import { FLOW_ID } from '@src/common/AppConstants';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { useOnloading } from '@src/state/landing';

const BoxHeader = styled('div', {
  paddingLeft: '20px',
  paddingTop: '30px',
});

const BoxHeaderText = styled('h3', {
  fontWeight: 600,
  fontSize: '22px',
  width: '100%',
  color: '$primary1',
  fontFamily: '$heading',
});

const InputDescription = styled('p', {
  padding: '20px',
  paddingTop: '10px',
  paddingBottom: '10px',
  fontFamily: '$primary',
});

const BoldText = styled('span', {
  fontWeight: 700,
});

export const RcmRedirect = ({ setTINvalidationError }) => {
  const router = useRouter();
  const { token } = useParams();
  const { setCurrentFlow } = useOnloading.actions();

  return (
    <React.Fragment>
      <BoxHeader>
        <BoxHeaderText>
          It looks like you may be working on behalf of a healthcare
          professional or facility.
        </BoxHeaderText>
      </BoxHeader>
      <InputDescription>
        To be granted 3rd Party Access for this TIN, you must contact the{' '}
        <BoldText>Primary Access Administrator (PAA).</BoldText>
      </InputDescription>
      <InputDescription>
        If you have not registered the organization you work for, you'll need to
        <BoldText> register as a billing or vendor organization </BoldText>to
        continue.
      </InputDescription>
      <InputDescription>
        For more information, see our{' '}
        <Link
          href={config('THIRD_PARTY_ACCESS_GUIDE')}
          onClick={() => {
            adobeTaggingEvent('DOWNLOAD_CLICKS', {
              downloadFileName: '3rd Party Access Guide',
              fileUrl: config('THIRD_PARTY_ACCESS_GUIDE'),
              fileContext: 'self paced chameleon guide',
            });
          }}
        >
          3rd Party Access Guide
        </Link>
        .
      </InputDescription>
      <Flex
        css={{
          'abyss-flex-root': {
            gap: '16px',
            justifyContent: 'center',
            padding: '16px',
          },
        }}
      >
        <Button
          variant="outline"
          onClick={() => {
            adobeTaggingEvent('RCM_CTA_CLICK', {
              interactionName:
                'It looks like you may be working on behalf of healthcare professional or facility modal',
              interactionValue: 'Register with your Company',
              interactionContext:
                'tin registration-healthcare professional or facility',
            });
            adobeTaggingEvent('COMPANY_VENDOR_MODAL_CLOSE', {
              modalName:
                'It looks like you may be working on behalf of healthcare professional or facility modal',
            });
            setTINvalidationError(null);
            setCurrentFlow(FLOW_ID.BILLING);
            router.navigate(`/TINValidation/${FLOW_ID.BILLING}/${token}`);
          }}
        >
          Register with your Company
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            adobeTaggingEvent('RCM_CTA_CLICK', {
              interactionName:
                'It looks like you may be working on behalf of healthcare professional or facility modal',
              interactionValue: 'Register as a Vendor',
              interactionContext:
                'tin registration-healthcare professional or facility',
            });
            adobeTaggingEvent('COMPANY_VENDOR_MODAL_CLOSE', {
              modalName:
                'It looks like you may be working on behalf of healthcare professional or facility modal',
            });
            setTINvalidationError(null);
            setCurrentFlow(FLOW_ID.VENDOR);
            router.navigate(`/TINValidation/${FLOW_ID.VENDOR}/${token}`);
          }}
        >
          Register as a Vendor
        </Button>
      </Flex>
    </React.Fragment>
  );
};

RcmRedirect.propTypes = {
  setTINvalidationError: PropTypes.func.isRequired,
};
RcmRedirect.defaultProps = {};
